import React, { useContext, useEffect, useState } from "react";

import DocumentBuilder from "./DocumentBuilder";
import { BlobProvider, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import { WsContext } from "../../App";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { useDispatch } from "react-redux";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

export default function PopupReportPdf(props) {
  const [winState, setWinState] = props.winState;
  const [loading, setLoading] = props.loading;

  const data = props.data;
  const userDetail = props.userInfo;

  const dispatch = useDispatch();
  const [docu, setDocu] = useState();

  // use web socket request
  const [ws, setWs] = useContext(WsContext);

  useEffect(() => {
    setDocu(
      <DocumentBuilder
        data={data}
        setLoading={setLoading}
        userDetail={userDetail}
      />
    );
  }, [data]);

  const handleClose = () => {
    setWinState((pv) => {
      pv.show = false;
      return { ...pv };
    });
  };

  const uploadPdfBlob = (bl, url, nextFnc) => {
    setLoading(true);
    var formData = new FormData();
    formData.append("userInfo", JSON.stringify(userDetail));
    formData.append("studyInfo", JSON.stringify(data?.studyInfo));
    formData.append("blob", bl);

    axios
      .post(
        process.env.REACT_APP_API + "api/rad-result/get-pdf-blob",
        formData,
        HttpJsonHeader
      )
      .then((res) => {
        setLoading(false);
        nextFnc("ok");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        nextFnc("err");
      });
  };

  const sendPacsToLoadPdf = () => {
    // * Send Websocket command
    // * 32201 = open folder or viewer app
    // let cmd = "31203";
    // let info = {
    //   userId: userDetail.userid,
    //   srcStaff: userDetail.staffid,
    //   targetStaff: userDetail.staffid,
    //   destStaff: userDetail.staffid,
    //   reqCommand: cmd,
    //   srcSessionType: 3,
    //   targetSessionType: 2,
    //   destSessionType: 2,
    //   studyId: data?.studyInfo?.pacs_study_id, //  study_instance_uid
    // };
    // ws?.sendJsonMessage(info);

    // dispatch(
    //   setReminder({
    //     show: true,
    //     message: "แจ้ง PACS เพื่อรับข้อมูลแล้ว",
    //     type: "success",
    //   })
    // );
    // setWinState({ show: false });
    if (winState.action) {
      winState.action();
    }
  };

  return (
    <MyModal
      style={{ zIndex: "10000" }}
      show={winState && winState.show}
      size="xl"
      centered
      fullscreen
    >
      <ModalHeaderBlack>
        <div
          style={{
            color: "black",
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          ผลการวินิจฉัย
        </div>
      </ModalHeaderBlack>

      {/* BODY */}
      <ModalBodyBlack style={{ padding: "0px" }}>
        <PDFViewer style={styles.container} children={docu}></PDFViewer>
      </ModalBodyBlack>

      {/* Footer */}
      <ModalFooterBlack>
        <div
          style={{
            flex: "1",
            display: "flex",
            marginLeft: "auto",
            marginRight: "auto",
            background: "none",
            borderRadius: "5px",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <BlobProvider document={docu}>
            {(a) => {
              if (a.url != null) {
                return (
                  <button
                    class="search-btn"
                    onClick={() => {
                      uploadPdfBlob(a.blob, a.url, (result) => {
                        if (result === "ok") {
                          sendPacsToLoadPdf();
                        }
                      });
                    }}
                  >
                    APPROVES
                  </button>
                );
              }
            }}
          </BlobProvider>

          {/*  */}

          {/*  */}

          <button
            class="clear-btn"
            onClick={() => {
              handleClose();
            }}
          >
            ยกเลิก
          </button>
        </div>
      </ModalFooterBlack>
    </MyModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "99%",
    height: "99%",
    marginHorizontal: 0,
  },
});
